import script from "./bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./bottom.vue?vue&type=script&setup=true&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=11c76996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c76996"]])

export default __exports__